import { CEDE_CEXS } from "@cede/types";

/**
 * Mapping of exchange IDs to their native tokens for fee reduction
 */
export const CEX_NATIVE_TOKENS = {
  [CEDE_CEXS.BINANCE]: "BNB",
  [CEDE_CEXS.MEXC]: "MX",
  [CEDE_CEXS.KUCOIN]: "KCS",
  [CEDE_CEXS.BITGET]: "BGB",
  [CEDE_CEXS.CRYPTOCOM]: "CRO",
  // Other exchanges don't have native tokens for fee reduction
} as const;

/**
 * Maximum fee discount percentages for each exchange when using native tokens
 */
export const CEX_FEE_DISCOUNT_PERCENTAGES = {
  [CEDE_CEXS.BINANCE]: 25,
  [CEDE_CEXS.MEXC]: 20,
  [CEDE_CEXS.KUCOIN]: 22,
  [CEDE_CEXS.BITGET]: 20,
  [CEDE_CEXS.CRYPTOCOM]: 30,
} as const;

/**
 * Documentation URLs for each exchange's fee reduction mechanism
 */
export const CEX_FEE_REDUCTION_DOCS = {
  [CEDE_CEXS.BINANCE]: "https://www.binance.com/en/support/faq/detail/115000583311",
  [CEDE_CEXS.MEXC]: "https://www.mexc.co/learn/article/how-to-use-mx-to-offset-trading-fees/1",
  [CEDE_CEXS.KUCOIN]: "https://www.kucoin.com/support/30380295503769",
  [CEDE_CEXS.BITGET]: "https://www.bitgetapp.com/academy/bitget-token-bgb-fee-deduction",
  [CEDE_CEXS.CRYPTOCOM]: "https://crypto.com/product-news/cro-revamp-exchange",
} as const;

/**
 * Get the native token for a given exchange
 */
export const getCexNativeToken = (exchangeId: string): string | null => {
  return CEX_NATIVE_TOKENS[exchangeId as keyof typeof CEX_NATIVE_TOKENS] || null;
};

/**
 * Get the fee reduction documentation URL for a given exchange
 */
export const getCexFeeReductionDocsUrl = (exchangeId: string): string | null => {
  return CEX_FEE_REDUCTION_DOCS[exchangeId as keyof typeof CEX_FEE_REDUCTION_DOCS] || null;
};

/**
 * Get the maximum fee discount percentage for a given exchange
 */
export const getCexFeeDiscountPercentage = (exchangeId: string): number | null => {
  return CEX_FEE_DISCOUNT_PERCENTAGES[exchangeId as keyof typeof CEX_FEE_DISCOUNT_PERCENTAGES] || null;
};

/**
 * Check if an exchange supports native token fee reduction
 */
export const exchangeSupportsNativeTokenFeeReduction = (exchangeId: string): boolean => {
  return exchangeId in CEX_NATIVE_TOKENS;
};
